{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/TINETTI",
	"name": "TINETTI",
	"language": "nl-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "TINETTI Schaal",
	"purpose": "Evaluatie van balans en gang",
	"description": "Een score lager dan 26 wijst gewoonlijk op een probleem; hoe lager de score, hoe groter het probleem. Een score lager dan 19 wijst op een vijfvoudig risico op vallen.",
	"item": [
		{
			"linkId": "100100",
			"text": "BALANS",
			"type": "group",
			"item": [
				{
					"linkId": "100100_helpText",
					"text": "Persoon is gezeten op een harde stoel zonder leuningen, de volgende manoeuvres worden getest.",
					"type": "display",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "help",
										"display": "Help-Button"
									}
								],
								"text": "Help-Button"
							}
						}
					]
				},
				{
					"linkId": "100200",
					"prefix": "1.",
					"text": "Zitbalans",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "100201",
								"display": "Zakt scheef of onderuit"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "100202",
								"display": "Zit stabiel en veilig"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						}
					]
				},
				{
					"linkId": "100300",
					"prefix": "2.",
					"text": "Rechtopstaan",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "100301",
								"display": "Onmogelijk zonder hulp"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "100302",
								"display": "Mogelijk met armsteun"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "100303",
								"display": "Mogelijk zonder armsteun"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					]
				},
				{
					"linkId": "100400",
					"prefix": "3.",
					"text": "Pogingen tot rechtopstaan",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "100401",
								"display": "Onmogelijk zonder hulp"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "100402",
								"display": "Mogelijk met meer dan 1 poging"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "100403",
								"display": "Mogelijk met 1 poging"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					]
				},
				{
					"linkId": "100500",
					"prefix": "4.",
					"text": "Balans in stand (eerste 5 seconden)",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "100501",
								"display": "Onstabiel (wankelt, voet- en rompbewegingen)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "100502",
								"display": "Stabiel met steun (rollator, stok of dergelijke)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "100503",
								"display": "Stabiel zonder enige steun"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					]
				},
				{
					"linkId": "100600",
					"prefix": "5.",
					"text": "Balans in stand",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "100601",
								"display": "Onstabiel"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "100602",
								"display": "Stabiel, voetafstand > 10 cm of armsteun"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "100603",
								"display": "Voeten gesloten, zonder steun"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					]
				},
				{
					"linkId": "100700",
					"prefix": "6.",
					"text": "Duwtje op sternum (3x) (voeten samen)",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "100701",
								"display": "Begint te wankelen"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "100702",
								"display": "Wankelt maar herstelt zich"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "100703",
								"display": "Stabiel"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					]
				},
				{
					"linkId": "100800",
					"prefix": "7.",
					"text": "Gesloten ogen (voeten samen)",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "100801",
								"display": "Onstabiel"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "100802",
								"display": "Stabiel"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						}
					]
				},
				{
					"linkId": "100900",
					"prefix": "8.",
					"text": "360° ronddraaien",
					"type": "group",
					"item": [
						{
							"linkId": "101000",
							"text": "Stapjes",
							"type": "choice",
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
									"valueCodeableConcept": {
										"coding": [
											{
												"system": "http://hl7.org/fhir/questionnaire-item-control",
												"code": "radio-button",
												"display": "Radio Button"
											}
										]
									}
								}
							],
							"required": true,
							"answerOption": [
								{
									"valueCoding": {
										"code": "101001",
										"display": "Onregelmatige stapjes"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 0
										}
									]
								},
								{
									"valueCoding": {
										"code": "101002",
										"display": "Regelmatige stapjes"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 1
										}
									]
								}
							]
						},
						{
							"linkId": "101100",
							"text": "Stabiliteit",
							"type": "choice",
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
									"valueCodeableConcept": {
										"coding": [
											{
												"system": "http://hl7.org/fhir/questionnaire-item-control",
												"code": "radio-button",
												"display": "Radio Button"
											}
										]
									}
								}
							],
							"required": true,
							"answerOption": [
								{
									"valueCoding": {
										"code": "101101",
										"display": "Onstabiel (wankelt)"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 0
										}
									]
								},
								{
									"valueCoding": {
										"code": "101102",
										"display": "Stabiel"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 1
										}
									]
								}
							]
						}
					]
				},
				{
					"linkId": "101200",
					"prefix": "9.",
					"text": "Gaan zitten",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "101201",
								"display": "Onveilig (valt, misrekening afstand)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "101202",
								"display": "Gebruikt armen"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "101203",
								"display": "Veilige en vloeiende beweging"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					]
				}
			]
		},
		{
			"linkId": "101300",
			"text": "GANG",
			"type": "group",
			"item": [
				{
					"linkId": "101300_helpText",
					"text": "Persoon staat samen met de onderzoeker; hij stapt in de gang of in de kamer, eerst aan een gewoon tempo, dan op de terugweg in een snellere maar veilige pas (hij gebruikt eigen hulpmiddelen zoals een stok of een looprek.",
					"type": "display",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "help",
										"display": "Help-Button"
									}
								],
								"text": "Help-Button"
							}
						}
					]
				},
				{
					"linkId": "101400",
					"prefix": "10.",
					"text": "Inzetten van gang na startwoord",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "101401",
								"display": "Aarzeling of verschillende pogingen"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "101402",
								"display": "Zonder aarzeling"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						}
					]
				},
				{
					"linkId": "101500",
					"prefix": "11.",
					"text": "Paslengte en hoogte",
					"type": "group",
					"item": [
						{
							"linkId": "101600",
							"text": "Re zwaaivoet paslengte",
							"type": "choice",
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
									"valueCodeableConcept": {
										"coding": [
											{
												"system": "http://hl7.org/fhir/questionnaire-item-control",
												"code": "radio-button",
												"display": "Radio Button"
											}
										]
									}
								}
							],
							"required": true,
							"answerOption": [
								{
									"valueCoding": {
										"code": "101601",
										"display": "Passeert de li standvoet niet"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 0
										}
									]
								},
								{
									"valueCoding": {
										"code": "101602",
										"display": "Passeert de li standvoet"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 1
										}
									]
								}
							]
						},
						{
							"linkId": "101700",
							"text": "Re zwaaivoet hoogte",
							"type": "choice",
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
									"valueCodeableConcept": {
										"coding": [
											{
												"system": "http://hl7.org/fhir/questionnaire-item-control",
												"code": "radio-button",
												"display": "Radio Button"
											}
										]
									}
								}
							],
							"required": true,
							"answerOption": [
								{
									"valueCoding": {
										"code": "101701",
										"display": "komt niet los van de grond"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 0
										}
									]
								},
								{
									"valueCoding": {
										"code": "101702",
										"display": "komt los van de grond"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 1
										}
									]
								}
							]
						},
						{
							"linkId": "101800",
							"text": "Li zwaaivoet paslengte",
							"type": "choice",
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
									"valueCodeableConcept": {
										"coding": [
											{
												"system": "http://hl7.org/fhir/questionnaire-item-control",
												"code": "radio-button",
												"display": "Radio Button"
											}
										]
									}
								}
							],
							"required": true,
							"answerOption": [
								{
									"valueCoding": {
										"code": "101801",
										"display": "Passeert de re standvoet niet"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 0
										}
									]
								},
								{
									"valueCoding": {
										"code": "101802",
										"display": "Passeert de re standvoet"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 1
										}
									]
								}
							]
						},
						{
							"linkId": "101900",
							"text": "Li zwaaivoet hoogte",
							"type": "choice",
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
									"valueCodeableConcept": {
										"coding": [
											{
												"system": "http://hl7.org/fhir/questionnaire-item-control",
												"code": "radio-button",
												"display": "Radio Button"
											}
										]
									}
								}
							],
							"required": true,
							"answerOption": [
								{
									"valueCoding": {
										"code": "101901",
										"display": "komt niet los van de grond"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 0
										}
									]
								},
								{
									"valueCoding": {
										"code": "101902",
										"display": "komt los van de grond"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 1
										}
									]
								}
							]
						}
					]
				},
				{
					"linkId": "102000",
					"prefix": "12.",
					"text": "Pas symmetrie",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "102001",
								"display": "Re en li staplengte zijn niet gelijk"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "102002",
								"display": "Re en li staplengte zijn gelijk"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						}
					]
				},
				{
					"linkId": "102100",
					"prefix": "13.",
					"text": "Pas continuïteit",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "102101",
								"display": "Haltes of discontinuïteit tussen passen"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "102102",
								"display": "Passen lijken continu"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						}
					]
				},
				{
					"linkId": "102200",
					"prefix": "14.",
					"text": "Afwijkende gang",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "102201",
								"display": "Opvallende afwijking"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "102202",
								"display": "Middelmatige afwijking of gebruik van loophulp"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "102203",
								"display": "Rechtuit zonder loophulp"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					]
				},
				{
					"linkId": "102300",
					"prefix": "15.",
					"text": "Romp",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "102301",
								"display": "Uitgesproken rompbeweging of gebruik van loophulp"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "102302",
								"display": "Geen rompbeweging maar flexie van knieën, rug of spreiding van armen"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "102303",
								"display": "Rechtop zonder loophulp"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					]
				},
				{
					"linkId": "102400",
					"prefix": "16.",
					"text": "Voetafstand",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "102401",
								"display": "Hielen uit elkaar"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "102402",
								"display": "Hielen raken mekaar bijna tijdens stappen"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						}
					]
				}
			]
		}
	]
}
